// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1eK9p","detailsBorder":"styles_detailsBorder__173Yg"};